document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('[data-s7-menu-toggle]');
  var drawer=document.querySelector('[data-s7-mobile-drawer]');
  var close=document.querySelector('[data-s7-menu-close]');
  function openMenu(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }}
  function closeMenu(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }}
  if(toggle) toggle.addEventListener('click', openMenu);
  if(close) close.addEventListener('click', closeMenu);
  if(drawer) drawer.addEventListener('click', function(e){ if(e.target===drawer) closeMenu(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeMenu(); });

  function sameOptions(a,b){ return a.length===b.length && a.every(function(v,i){return v===b[i];}); }
  function optionKind(row){
    var name=(row.getAttribute('data-option-name')||'').toLowerCase();
    if(name.indexOf('color')>-1 || name.indexOf('colour')>-1) return 'color';
    if(name.indexOf('storage')>-1 || name.indexOf('capacity')>-1 || name.indexOf('gb')>-1) return 'storage';
    if(name.indexOf('condition')>-1 || name.indexOf('grade')>-1) return 'condition';
    return 'option';
  }

  document.querySelectorAll('[data-s7-product]').forEach(function(root){
    var jsonEl=root.querySelector('[data-s7-variants-json]');
    var idInput=root.querySelector('[data-s7-variant-id]');
    var priceEl=root.querySelector('[data-s7-price]');
    var compareEl=root.querySelector('[data-s7-compare-at]');
    var vsNewEl=root.querySelector('[data-s7-vs-new]');
    var addBtn=root.querySelector('[data-s7-add-to-cart]');
    var stickyBar=root.querySelector('[data-s7-sticky-bar]');
    var stickyBtn=root.querySelector('[data-s7-sticky-add]');
    var stickyPrice=root.querySelector('[data-s7-sticky-price]');
    var stickyVariant=root.querySelector('[data-s7-sticky-variant]');
    var statusEl=root.querySelector('[data-s7-variant-status]');
    var imageWrap=root.querySelector('[data-s7-main-image]');
    var form=root.querySelector('form.s7-v8-form, form.s7-product-form');
    var buttons=[].slice.call(root.querySelectorAll('[data-s7-option-value]'));
    var rows=[].slice.call(root.querySelectorAll('[data-s7-option-row]'));
    if(!jsonEl || !idInput || !buttons.length) return;

    var variants=[];
    try { variants=JSON.parse(jsonEl.textContent || '[]'); } catch(e){ variants=[]; }
    if(!variants.length) return;

    var selected=[];
    buttons.forEach(function(btn){
      var idx=parseInt(btn.getAttribute('data-s7-option-index'),10);
      if(btn.classList.contains('is-active')) selected[idx]=btn.getAttribute('data-s7-option-value');
    });
    variants[0].options.forEach(function(v,i){ if(!selected[i]) selected[i]=v; });

    function matchingVariant(opts){
      return variants.find(function(v){ return sameOptions(v.options, opts); });
    }
    function firstPossibleWith(idx,value){
      return variants.find(function(v){
        if(v.options[idx]!==value) return false;
        return v.options.every(function(opt,i){ return i===idx || !selected[i] || opt===selected[i]; });
      }) || variants.find(function(v){ return v.options[idx]===value; });
    }
    function optionCombinationPossible(idx,value){
      var test=selected.slice();
      test[idx]=value;
      return variants.some(function(v){ return sameOptions(v.options,test); });
    }
    function findVariantForCondition(conditionIndex, conditionValue){
      var test=selected.slice();
      test[conditionIndex]=conditionValue;
      return matchingVariant(test) || variants.find(function(v){ return v.options[conditionIndex]===conditionValue; });
    }

    function updateSelectedLabels(){
      root.querySelectorAll('[data-s7-selected-label]').forEach(function(label){
        var idx=parseInt(label.getAttribute('data-s7-selected-index'),10);
        label.textContent=selected[idx] || '';
      });
    }

    function updateConditionPrices(){
      rows.forEach(function(row){
        if(optionKind(row)!=='condition') return;
        var idx=parseInt(row.getAttribute('data-option-index'),10);
        row.querySelectorAll('[data-s7-condition-price]').forEach(function(el){
          var value=el.getAttribute('data-condition-value');
          var v=findVariantForCondition(idx,value);
          el.textContent=v && v.price ? v.price : '';
        });
      });
    }

    function updateButtons(){
      buttons.forEach(function(btn){
        var idx=parseInt(btn.getAttribute('data-s7-option-index'),10);
        var value=btn.getAttribute('data-s7-option-value');
        var active=selected[idx] === value;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        var possible=optionCombinationPossible(idx,value) || !!firstPossibleWith(idx,value);
        btn.classList.toggle('is-disabled', !possible);
        btn.disabled=!possible;
      });
      updateSelectedLabels();
      updateConditionPrices();
    }

    function setMainImage(variant){
      if(!imageWrap || !variant || !variant.image || !variant.image.src) return;
      var img=imageWrap.querySelector('img');
      if(!img){
        imageWrap.innerHTML='';
        img=document.createElement('img');
        img.width=1100; img.loading='eager';
        imageWrap.appendChild(img);
      }
      img.src=variant.image.src;
      img.alt=variant.image.alt || '';
    }

    function updateDiscountBadge(variant){
      var badge=root.querySelector('[data-s7-discount-badge]');
      if(!badge) return;
      badge.textContent = variant && variant.compareAt ? 'Deal vs new' : 'Certified Renewed';
    }

    function applyVariant(variant, replaceUrl){
      if(!variant) return;
      selected=variant.options.slice();
      idInput.value=variant.id;
      if(priceEl) priceEl.textContent=variant.price || '';
      if(compareEl) compareEl.textContent=variant.compareAt || '';
      if(vsNewEl) vsNewEl.textContent=variant.compareAt ? 'vs new' : '';
      if(stickyPrice) stickyPrice.textContent=variant.price || '';
      if(stickyVariant) stickyVariant.textContent=variant.title || '';
      if(addBtn){ addBtn.disabled=!variant.available; addBtn.textContent=variant.available ? 'Add to Cart' : 'Sold Out'; }
      if(stickyBtn){ stickyBtn.disabled=!variant.available; stickyBtn.textContent=variant.available ? 'Add to Cart' : 'Sold Out'; }
      if(statusEl) statusEl.textContent=variant.available ? '' : 'Selected option is sold out.';
      setMainImage(variant);
      updateDiscountBadge(variant);
      updateButtons();
      if(replaceUrl!==false && window.history && window.history.replaceState){
        var url=new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    buttons.forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        var idx=parseInt(btn.getAttribute('data-s7-option-index'),10);
        var value=btn.getAttribute('data-s7-option-value');
        var test=selected.slice();
        test[idx]=value;
        var variant=matchingVariant(test);
        if(!variant){
          variant=firstPossibleWith(idx,value);
          if(variant) test=variant.options.slice();
        }
        if(!variant){
          selected[idx]=value;
          if(statusEl) statusEl.textContent='This combination is not available.';
          updateButtons();
          return;
        }
        applyVariant(variant,true);
      });
    });

    root.querySelectorAll('[data-s7-thumb-src]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        if(!imageWrap) return;
        root.querySelectorAll('[data-s7-thumb-src]').forEach(function(t){t.classList.remove('is-active');});
        thumb.classList.add('is-active');
        var img=imageWrap.querySelector('img');
        if(!img){ imageWrap.innerHTML=''; img=document.createElement('img'); img.width=1100; imageWrap.appendChild(img); }
        img.src=thumb.getAttribute('data-s7-thumb-src');
        img.alt=thumb.getAttribute('data-s7-thumb-alt') || '';
      });
    });

    if(stickyBtn && form){
      stickyBtn.addEventListener('click',function(){
        if(stickyBtn.disabled) return;
        if(form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
    if(stickyBar){
      var trigger=function(){ stickyBar.classList.toggle('is-visible', window.scrollY > 520); };
      trigger(); window.addEventListener('scroll', trigger, {passive:true});
    }

    var params=new URLSearchParams(window.location.search);
    var urlVariantId=params.get('variant');
    var initial= urlVariantId ? variants.find(function(v){ return String(v.id)===String(urlVariantId); }) : null;
    initial=initial || matchingVariant(selected) || variants[0];
    applyVariant(initial,false);
  });
});
